<template>
  <el-row>
    <el-row :class="columnClass" justify="start">
      <span>{{isInspect ? '巡检路线' : '操作步骤'}}</span>
      <div class="navbar-right">
        <el-button type="info" plain size="minimum" @click="toAdd" :disabled="!addable">新增</el-button>
      </div>
    </el-row>
    <el-row class="bottom20">
      <!-- isSop || isMop -->
      <el-table :data="page.records" v-show="isSop || isMop">
        <el-table-column prop="jptask" width="80px">
          <template slot="header" slot-scope="scope">
            序号
          </template>
        </el-table-column>
        <el-table-column prop="description">
          <template slot="header" slot-scope="scope">
            操作步骤
          </template>
          <template slot-scope="scope">
            <athub-short-text :text="scope.row.description" :show-max-length="76"></athub-short-text>
          </template>
        </el-table-column>
        <el-table-column prop="requirement">
          <template slot="header" slot-scope="scope">
            技术要求
          </template>
          <template slot-scope="scope">
            <athub-short-text :text="scope.row.requirement" :show-max-length="76"></athub-short-text>
          </template>
        </el-table-column>
        <el-table-column prop="riskcontrol">
          <template slot="header" slot-scope="scope">
            风控点
          </template>
          <template slot-scope="scope">
            <athub-short-text :text="scope.row.riskcontrol" :show-max-length="76"></athub-short-text>
          </template>
        </el-table-column>
        <el-table-column prop="taskduration" width="120px">
          <template slot="header" slot-scope="scope">
            时长（分钟）
          </template>
        </el-table-column>
        <el-table-column prop="attachment" width="120px">
          <template slot="header" slot-scope="scope">
            提示图片
          </template>
          <template slot-scope="scope">
            <image-edit :owner-table="'JOBTASK'" :doc-type="'JOBTASK'" :owner-id="scope.row.jobtaskid"
                        :editable="updatable"></image-edit>
          </template>
        </el-table-column>
        <el-table-column width="190px">
          <template slot="header" slot-scope="scope">
            操作
          </template>
          <template slot-scope="scope">
            <div>
              <el-button type="primary" plain size="minimum" @click="toInsert(scope.row)" :disabled="!addable">插入</el-button>
              <el-button type="warning" plain size="minimum" @click="toEdit(scope.row)" :disabled="!updatable">修改</el-button>
              <el-button type="danger" plain size="minimum" @click="toDelete(scope.row)" :disabled="!deletable">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- isEop -->
      <el-table :data="page.records" v-show="isEop">
        <el-table-column prop="jptask" width="80px">
          <template slot="header" slot-scope="scope">
            序号
          </template>
        </el-table-column>
        <el-table-column prop="description">
          <template slot="header" slot-scope="scope">
            操作步骤
          </template>
          <template slot-scope="scope">
            <athub-short-text :text="scope.row.description" :show-max-length="76"></athub-short-text>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="scope">
            操作
          </template>
          <template slot-scope="scope">
            <div>
              <el-button type="primary" plain size="minimum" @click="toInsert(scope.row)" :disabled="!addable">插入</el-button>
              <el-button type="warning" plain size="minimum" @click="toEdit(scope.row)" :disabled="!updatable">修改</el-button>
              <el-button type="danger" plain size="minimum" @click="toDelete(scope.row)" :disabled="!deletable">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- isInspect -->
      <el-table :data="page.records" v-show="isInspect">
        <el-table-column prop="jptask" width="80px">
          <template slot="header" slot-scope="scope">
            序号
          </template>
        </el-table-column>
        <el-table-column prop="locationCode">
          <template slot="header" slot-scope="scope">
            房间编号
          </template>
        </el-table-column>
        <el-table-column prop="locationDesc">
          <template slot="header" slot-scope="scope">
            房间名称
          </template>
        </el-table-column>
        <el-table-column prop="taskduration">
          <template slot="header" slot-scope="scope">
            时长（分钟）
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="scope">
            操作
          </template>
          <template slot-scope="scope">
            <div>
              <el-button type="primary" plain size="minimum" @click="toInsert(scope.row)" :disabled="!addable">插入</el-button>
              <el-button type="warning" plain size="minimum" @click="toEdit(scope.row)" :disabled="!updatable">修改</el-button>
              <el-button type="danger" plain size="minimum" @click="toDelete(scope.row)" :disabled="!deletable">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- isOther -->
      <el-table :data="page.records" v-show="isOther">
        <el-table-column prop="jptask" width="80px">
          <template slot="header" slot-scope="scope">
            序号
          </template>
        </el-table-column>
        <el-table-column prop="description">
          <template slot="header" slot-scope="scope">
            操作内容
          </template>
        </el-table-column>
        <!--<el-table-column prop="rollback">
          <template slot="header" slot-scope="scope">
            回退方案
          </template>
        </el-table-column>-->
        <el-table-column prop="taskduration">
          <template slot="header" slot-scope="scope">
            时长（分钟）
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="scope">
            操作
          </template>
          <template slot-scope="scope">
            <div>
              <el-button type="primary" plain size="minimum" @click="toInsert(scope.row)" :disabled="!addable">插入</el-button>
              <el-button type="warning" plain size="minimum" @click="toEdit(scope.row)" :disabled="!updatable">修改</el-button>
              <el-button type="danger" plain size="minimum" @click="toDelete(scope.row)" :disabled="!deletable">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="pageSearch.current"
              :page-sizes="[10, 25, 50, 100]"
              :page-size="pageSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </el-row>

    <el-row>
      <el-dialog :title="isInspect ? '巡检路线' : '操作步骤'" :visible.sync="stepDialogVisible">
        <el-form :model="form.model" :rules="formRules" :validate-on-rule-change="false" ref="form">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="isEop ? 24 : 12" :lg="isEop ? 24 : 12">
              <el-form-item label="序号" prop="jptask">
                <el-input v-model="form.model.jptask" :disabled="true" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="locationExisted">
              <el-form-item label="房间名称" prop="locationId">
                <el-select v-model="form.model.locationId" :filterable="true" :clearable="true" size="small" class="width100">
                  <el-option v-for="item in locationDictionary.items" :key="item[locationDictionary.valueKey]"
                             :label="item[locationDictionary.textKey]" :value="item[locationDictionary.valueKey]">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="taskdurationExisted">
              <el-form-item label="时长（分钟）" prop="taskduration">
                <el-input-number v-model="form.model.taskduration" :precision="1" :step="0.1" :min="0.1" size="small" class="width100"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="isEop ? 24 : 12" :lg="isEop ? 24 : 12" v-if="descriptionExisted">
              <el-form-item :label="descriptionShowText" prop="description">
                <el-input v-model="form.model.description" type="textarea" :maxlength="is3P ? 500 : 120" :placeholder="is3P ? '限500个字符' : '限120个字符'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="requirementExisted">
              <el-form-item label="技术要求" prop="requirement">
                <el-input v-model="form.model.requirement" type="textarea" maxlength="500" placeholder="限500个字符"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="riskcontrolExisted">
              <el-form-item label="风控点" prop="riskcontrol">
                <el-input v-model="form.model.riskcontrol" type="textarea" maxlength="500" placeholder="限500个字符"></el-input>
              </el-form-item>
            </el-col>
            <!--<el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="rollbackExisted">
              <el-form-item label="回退方案" prop="rollback">
                <el-input v-model="form.model.rollback" type="textarea" size="small"></el-input>
              </el-form-item>
            </el-col>-->
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row>
            <el-button @click="stepDialogVisible = false" size="small">取 消</el-button>
            <el-button type="primary" @click="save" size="small">确 定</el-button>
            <el-button type="primary" @click="saveAndAssetAttr" size="small" v-if="isSop || isMop">确定并配置点位类型</el-button>
          </el-row>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="jobPlanSpecAddDialogVisible" v-if="isSop || isMop" width="70%">
        <job-plan-spec-add ref="jobPlanSpecAdd"
                           :job-plan-id="jobPlanId"
                           :job-task-id="jobTaskId"
                           :operate-exist="operateExist"
                           :check-exist="checkExist"
                           @success="jobPlanSpecAddSuccess"
        ></job-plan-spec-add>
        <div slot="footer" class="dialog-footer">
          <el-row>
            <el-button @click="jobPlanSpecAddDialogVisible = false" size="small">取 消</el-button>
            <el-button type="primary" @click="saveJobPlanSpect" size="small">保 存</el-button>
          </el-row>
        </div>
      </el-dialog>
    </el-row>
  </el-row>
</template>

<script>
  import Emitter from 'element-ui/src/mixins/emitter'
  import { debounce, merge } from "@/util/common"
  import { AuthInfo } from '@/util/user/authInfo'
  import { Dictionary, dictionaryContainer } from "@/util/common/dictionary"
  import {selected, visited, pageFactory} from  '@/views/workorder/mixins/table'
  import {WorkOrderServer} from  '@/api'
  import AthubCloudApi from  '@/api/athubCloud'
  import ImageEdit from  '@/views/workorder/components/image/edit'
  import JobPlanSpecAdd from '@/views/workorder/jobplan/jobplanspec/add'

  import { JobPlan } from '../mixins'
  import AthubShortText from "../../components/athub-short-text";
  export default {
    name: "JobTaskList",
    mixins: [Emitter, selected, visited, pageFactory({debounce: 200}), JobPlan],
    components: {
      AthubShortText,
      ImageEdit,
      JobPlanSpecAdd
    },
    props: {
      jobPlan: {},
      jobPlanScene: {},
      titleClass: {
      },
      addable: {
        type: Boolean,
        default: false,
      },
      updatable: {
        type: Boolean,
        default: false,
      },
      deletable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        pageSearch: {
          search: {
            jobplanid: -1,
            jobplansceneid: null,
          }
        },
        stepDialogVisible: false,
        operation: '',
        form: {
          model: {
            jobplanid: '',
            jobplansceneid: '',
            jptask: '',
            tasksequence: '',
            taskduration: '',
            description: '',
            requirement: '',
            riskcontrol: '',
            locationId: null,
            locationCode: null,
            locationDesc: null,
            locationType: null,
          },
        },

        // locationDictionary: new Dictionary({items: []}),
        locations: [],
        rooms: [],

        jobPlanId: null,
        type: null,
        isStandard: null,

        jobPlanSpecAddDialogVisible: false,
        operateExist: true,
        checkExist: true,
        jobTaskId: null,
      };
    },
    computed: {
      descriptionExisted() {
        return this.isSop || this.isMop || this.isEop || this.isOther;
      },
      requirementExisted() {
        return this.isSop || this.isMop;
      },
      riskcontrolExisted() {
        return this.isSop || this.isMop;
      },
      rollbackExisted() {
        return this.isOther;
      },
      locationExisted() {
        return this.isInspect;
      },
      taskdurationExisted() {
        return this.isInspect || this.isSop || this.isMop || this.isOther;
      },
      attachmentExisted() {
        return this.isSop || this.isMop;
      },
      descriptionShowText() {
        return this.isOther ? '操作内容' : '操作步骤';
      },
      formRules() {
        let rules = {};
        if (this.locationExisted) {
          rules.locationId = [
            {required: true, message: '请选择房间', trigger: 'change'}
          ];
        }
        if (this.descriptionExisted) {
          rules.description = [
            {required: true, message: this.descriptionShowText, trigger: 'blur'}
          ];
        }
        if (this.isInspect || this.is3P) {
          rules.taskduration = [
            {required: true, message: '请填写时长', trigger: 'blur'}
          ];
        }
        return rules;
      },
      columnClass() {
        let clazz = {};
        if (this.titleClass == null) {
          clazz = {'column-name': true};
        } else {
          clazz = this.titleClass;
        }
        return clazz;
      },
      locationDictionary() {
        let locationDictionary;
        let locations = this.locations, items = [];
        if (this.isInspect) {
          let i, l, location, locationDesc;
          for (i = 0, l = locations.length; i < l; i++) {
            location = locations[i];
            if (location['dcnum'] == null || location != null && location['dcnum'].toString() === '') {
              locationDesc = location['description'];
            } else {
              if (location['description'].indexOf(location['dcnum']) === -1) {
                locationDesc = location['dcnum'] + location['description'];
              } else {
                locationDesc = location['description'];
              }
            }
            location.showLocationDesc = locationDesc;
            items.push(location);
          }
        }
        let dnums = this.rooms.map(e => e.DCNUM);
        if (dnums.length > 0) {
          items = items.filter(e => e.dcnum != null && dnums.indexOf(e.dcnum) !== -1);
        }
        locationDictionary = new Dictionary({items: items, valueKey: 'locationid', textKey: 'showLocationDesc'});
        return locationDictionary;
      }
    },
    watch: {
      jobPlan: {
        immediate: true,
        deep: true,
        handler() {
          this.jobPlanId = this.jobPlan.jobplanid;
          this.type = this.jobPlan.type;
          this.isStandard = this.jobPlan.isstandard;

          this.pageSearch.search.jobplanid = this.jobPlanId == null ? -1 : this.jobPlanId;
        }
      },
      'jobPlan.deptid': {
        immediate: true,
        deep: true,
        handler(value) {
          if (value != null) {
            AthubCloudApi.getRoomsByDeptIds([value]).then((res) => {
              this.rooms = res;
            });
          } else {
            this.rooms = [];
          }
        }
      },
      jobPlanScene: {
        immediate: true,
        deep: true,
        handler() {
          if (this.jobPlanScene != null) {
            this.pageSearch.search.jobplansceneid = this.jobPlanScene['jobplansceneid'];
          }
        }
      },
      isInspect: {
        immediate: true,
        handler() {
          if (this.isInspect) {
            this._loadLocations();
          } else {
            this.locations = [];
          }
        },
      },
      'form.model.locationId': {
        immediate: true,
        handler(value) {
          if (value != null) {
            let item = this.locationDictionary.getItem(value, 'locationid');
            this.form.model.locationCode = item.location;
            this.form.model.locationDesc = item.showLocationDesc;
            this.form.model.locationType = item.type;
          } else {
            this.form.model.locationCode = null;
            this.form.model.locationDesc = null;
            this.form.model.locationType = null;
          }
        },
      }
    },
    methods: {
      queryByPage(pageSearch) {
        console.log(`jobtask query by page...`, pageSearch);

        WorkOrderServer.jobTask.page(pageSearch).then((res) => {
          if (res.data.code === 200) {
            this.page = {
              total: res.data.result.total,
              records: res.data.result.records,
            };
          }
        });
      },
      toAdd() {
        WorkOrderServer.jobTask.getMaxTaskSequence(
            this.jobPlanId,
            this.jobPlanScene != null ? this.jobPlanScene['jobplansceneid'] : null
        ).then((res) => {
          if (res.data.code === 200) {
            let max = res.data.result, next = max + 1;
            this.stepDialogVisible = true;
            if (this.$refs.form != null) {
              this.$refs.form.resetFields();
            }
            this.form.model = {
              jobplanid: this.jobPlanId,
              jobplansceneid: this.jobPlanScene != null ? this.jobPlanScene['jobplansceneid'] : null,
              jptask: next,
              tasksequence: next,
            };
            this.operation = 'add';
          } else {
            this.$message.error(res.data.message);
          }
        });
      },
      toInsert(data) {
        this.stepDialogVisible = true;
        if (this.$refs.form != null) {
          this.$refs.form.resetFields();
        }
        let prev = data['tasksequence'];
        this.form.model = {
          jobplanid: this.jobPlanId,
          jobplansceneid: this.jobPlanScene != null ? this.jobPlanScene['jobplansceneid'] : null,
          jptask: prev,
          tasksequence: prev,
        };
        this.operation = 'add';
      },
      toEdit(data) {
        this.stepDialogVisible = true;
        if (this.$refs.form != null) {
          this.$refs.form.resetFields();
        }
        this.form.model = merge(true, {}, data);
        this.operation = 'edit';
      },
      toDelete(data) {
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          WorkOrderServer.jobTask.delete(data['jobtaskid'], {loading: true}).then((res) => {
            if (res.data.code === 200) {
              this.$message.success('删除成功！');
              this.dispatch('JobplanIndex', 'switch-operation', 'operate-param.refresh');
              this.executeQueryByPage();
            } else {
              this.$message.error('删除失败！');
            }
          });
        })
      },
      save() {
        this.$refs['form'].validate((res) => {
          if (res) {
            if (this.operation === 'add') {
              let data = merge(true, {}, this.form.model);
              data.enterby = AuthInfo.userName;
              data.enterbyname = AuthInfo.userRealName;
              data.enterdate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              data.changeby = AuthInfo.userName;
              data.changebyname = AuthInfo.userRealName;
              data.changedate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              WorkOrderServer.jobTask.add(data).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('新增成功！');
                  this.stepDialogVisible = false;
                  this.executeQueryByPage();
                }
              });
            } else if (this.operation === 'edit') {
              let data = merge(true, {}, this.form.model);
              data.changeby = AuthInfo.userName;
              data.changebyname = AuthInfo.userRealName;
              data.changedate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              WorkOrderServer.jobTask.update(data['jobtaskid'], data).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('保存成功！');
                  this.stepDialogVisible = false;
                  this.executeQueryByPage();
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      saveAndAssetAttr() {
        this.$refs['form'].validate((res) => {
          if (res) {
            if (this.operation === 'add') {
              let data = merge(true, {}, this.form.model);
              data.enterby = AuthInfo.userName;
              data.enterbyname = AuthInfo.userRealName;
              data.enterdate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              data.changeby = AuthInfo.userName;
              data.changebyname = AuthInfo.userRealName;
              data.changedate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              WorkOrderServer.jobTask.add(data).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('新增成功！');
                  this.stepDialogVisible = false;
                  this.executeQueryByPage();
                  this.jobPlanSpecAddDialogVisible = true;
                  this.$nextTick(() => {
                    this.$refs.jobPlanSpecAdd.clear();
                    this.$refs.jobPlanSpecAdd.loadJobTasks(); // 重新查询操作步骤
                    this.jobTaskId = res.data.result.jobtaskid;
                  });
                }
              });
            } else if (this.operation === 'edit') {
              let data = merge(true, {}, this.form.model);
              data.changeby = AuthInfo.userName;
              data.changebyname = AuthInfo.userRealName;
              data.changedate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              WorkOrderServer.jobTask.update(data['jobtaskid'], data).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('保存成功！');
                  this.stepDialogVisible = false;
                  this.executeQueryByPage();
                  this.jobPlanSpecAddDialogVisible = true;
                  this.$nextTick(() => {
                    this.$refs.jobPlanSpecAdd.clear();
                    this.$refs.jobPlanSpecAdd.loadJobTasks(); // 重新查询操作步骤
                    this.jobTaskId = res.data.result.jobtaskid;
                  });
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      saveJobPlanSpect() {
        this.$refs['jobPlanSpecAdd'].submit();
      },
      jobPlanSpecAddSuccess() {
        this.jobPlanSpecAddDialogVisible = false;
        // this.$emit('switch-operation', 'operate-param.refresh');
        this.dispatch('JobplanIndex', 'switch-operation', 'operate-param.refresh');
      },
      _loadLocations() {
        AthubCloudApi.getLocations().then((res) => {
          this.locations = res;
        });
      }
    },
  }
</script>

<style scoped>

</style>